export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    'big_win': [
      0,
      5014.058956916099,
    ],
    'button_spin': [
      7000,
      1101.4965986394554,
    ],
    'free_bet_big_win': [
      10000,
      1377.2335600907031,
    ],
    'free_bet_mega_win': [
      13000,
      2213.151927437641,
    ],
    'free_bet_total_win': [
      17000,
      979.591836734695,
    ],
    'free_bet_ultra_win': [
      19000,
      1319.1836734693893,
    ],
    'inside_buttons': [
      22000,
      224.9433106575971,
    ],
    'kavuny-background-to-loop': [
      24000,
      14428.639455782317,
    ],
    'main_ambient': [
      40000,
      70751.20181405896,
    ],
    'mega_win': [
      112000,
      5077.9138321995415,
    ],
    'outside_buttons': [
      119000,
      320.72562358276,
    ],
    'reel_spin': [
      121000,
      2332.1541950113415,
    ],
    'reel_stop_01': [
      125000,
      219.1383219954588,
    ],
    'reel_stop_02': [
      127000,
      236.55328798186304,
    ],
    'reel_stop_03': [
      129000,
      262.6757369614552,
    ],
    'reel_stop_04': [
      131000,
      193.01587301586665,
    ],
    'reel_stop_05': [
      133000,
      201.72335600906877,
    ],
    'regular_win': [
      135000,
      1414.9659863945487,
    ],
    'tap_to_play': [
      138000,
      2221.859410430852,
    ],
    'ultra_win': [
      142000,
      3928.5260770975015,
    ],
    'x2_win': [
      147000,
      1943.2199546485265,
    ],
  },
}
